import React from 'react';
import { ConfigContext, defaultConfig } from './config-context';
/** @deprecated */
export const ConfigProvider = _ref => {
  let {
    config,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: {
      ...defaultConfig,
      ...config
    }
  }, children);
};